import { render, staticRenderFns } from "./IntakeForm.vue?vue&type=template&id=1050862d&"
import script from "./IntakeForm.vue?vue&type=script&lang=js&"
export * from "./IntakeForm.vue?vue&type=script&lang=js&"
import style0 from "./IntakeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports